module.exports = __webpack_public_path__ + "static/img/effectbannerbg1.19356f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/advertisement/introduceFour/effectbannerbg1.png
// module id = /+LW
// module chunks = 171